import React, { useState } from 'react';
import BannerBg from '../../../local-assets/faq-v2/bg-banner.png';
import BannerBgSecondary from '../../../local-assets/faq-v2/bg-banner-secondary.png';
import BannerBgPerson from '../../../local-assets/faq-v2/bg-banner-person.png';

const Banner = () => {
  return (
    <header className="pt-20 relative w-full bg-gradient-to-br from-[#FF7A00] to-[#E65C00] rounded-br-[3rem] md:rounded-br-[5rem] overflow-hidden">
      <img 
        src={BannerBgSecondary}
        alt="Banner Pattern"
        className="absolute bottom-0 right-0 w-full md:w-[60%] h-[70%] md:h-full object-cover md:object-contain object-right-bottom pointer-events-none opacity-90"
      />
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex flex-col md:flex-row items-stretch min-h-[550px] md:min-h-[420px]">

        {/* 3. SISI KIRI: TEKS KONTEN */}
        <div className="w-full md:w-[55%] flex flex-col justify-center text-left text-white py-12 md:py-16">
          <p className="text-sm md:text-base font-semibold mb-2 drop-shadow-sm">
            Summarecon Apps
          </p>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 md:mb-6 drop-shadow-sm">
            Frequently <br />
            Ask Question
          </h1>
          
          <p className="text-sm md:text-base leading-relaxed opacity-95 max-w-lg">
            Ingin tahu lebih lanjut tentang fitur dan mekanisme Summarecon Apps, lihat FAQ kami untuk jawaban atas pertanyaanmu.
          </p>
        </div>

        {/* 4. SISI KANAN: GAMBAR ORANG & ICON */}
        <div className="w-full md:w-[45%] flex justify-center md:justify-end items-end relative mt-auto">
          {/* Gambar dibuat menempel persis ke garis bawah container (items-end & object-bottom) */}
          <img 
            src={BannerBgPerson}
            alt="FAQ Person"
            className="h-[320px] md:h-[400px] lg:h-[450px] w-auto object-contain object-bottom drop-shadow-xl z-20"
          />
        </div>

      </div>
    </header>
  );
};

export default Banner;